import type { ReactNode } from "react";

/** Keeps identifiers, currencies, contacts, URLs, and reference codes stable inside RTL copy. */
export function Ltr({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <bdi dir="ltr" className={`inline-block unicode-bidi-isolate ${className}`}>{children}</bdi>;
}

export function BidiText({ children }: { children: ReactNode }) {
  return <bdi dir="auto">{children}</bdi>;
}